const ChatRole = Object.freeze({
  USER: 'user',
  ASSISTANT: 'assistant',
  SYSTEM: 'system',
  FUNCTION: 'function',
} as const);

export type ChatRole = (typeof ChatRole)[keyof typeof ChatRole];

export default ChatRole;
